<template lang="pug" src='./nav-desktop.pug'></template>

<script>
import Icon from 'components/icon/icon'
import { showModal, toggleMenu, goToPayments } from '@/mixins'

export default {
  computed: {
    links () {
      return this.$router.options.routes
    },
    props () {
      return this.$store.state.app
    }
  },
  components: {
    Icon
  },
  mixins: [ showModal, toggleMenu, goToPayments ],
  methods: {
    moveTo (i) {
      this.$store.dispatch('VIEW_DRAWER', false)
      setTimeout(() => {
        this.$options.parent.$parent.$refs.home.$fullpage.moveTo(i, true)
      }, 350)
    }
  }
}
</script>



// WEBPACK FOOTER //
// nav-desktop.vue?19d40eaa